import React, { FC } from 'react';
import { ContainerLarge as Container } from '../../components/base/grid';
import Recipients from '../../components/myPost/recipients';
import pageWrapper from '../../hoc/pageWrapper';
import IMyShipmentsViewModel from '../../interfaces/myShipments/myShipments';

interface Props {
	page: IMyShipmentsViewModel;
}

const MyShipmentsRecipients: FC<Props> = ({ page }) => {
	return (
		<Container>
			<Recipients page={page} />
		</Container>
	);
};

export default pageWrapper(MyShipmentsRecipients);
